import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { filterByTextSearch } from '../../packages/kiti/utils/helpers/search'
import { integrationsClient } from '../../utils/apollo/api'
import { usePromiseQuery } from '../../utils/apollo/_helpers/promiseQuery'
import Select from '../../packages/kiti/components/form/Select'

const QUERY = gql`
  query FoldersD4signs($integrationId: Int, $safeId: String) {
    foldersD4signs(integrationId: $integrationId, safeId: $safeId) {
      id
      name
    }
  }
`

const useSafeLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient, fetchPolicy: 'cache-first' })
  return (search, page = 1) => {
    return query(filter) //
      ?.then(pathOr([], ['data', 'foldersD4signs']))
      ?.then(folders => filterByTextSearch(folders, search))
  }
}

const FolderD4signSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useSafeLoader(filter)

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      {...props}
    />
  )
}

export default FolderD4signSelect
